<!--<div>
    <div style="width: calc(136px - 31px)" attr.data-cy="{{item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].value?.toolTip ? item.cells[fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}" *ngIf="item && item.cells" class="grid-cell-ellipsis"
      matTooltip="{{item.cells[fieldDefinition.key] ? (item.cells[fieldDefinition.key].value?.toolTip ? item.cells[fieldDefinition.key].value?.toolTip : item.cells[fieldDefinition.key].displayText) : ''}}"
      [innerHTML]="item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''| sanitizeHtml">
</div>
    <div style="width: calc(136px - 31px)" attr.data-cy="{{item.cells[fieldDefinition.metaData.MiniNoteKey] ? (item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip ? item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip : item.cells[fieldDefinition.metaData.MiniNoteKey].displayText) : ''}}" *ngIf="item && item.cells" class="grid-cell-ellipsis"
       matTooltip="{{item.cells[fieldDefinition.metaData.MiniNoteKey] ? (item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip ? item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip : item.cells[fieldDefinition.metaData.MiniNoteKey].displayText) : ''}}"
       [innerHTML]="item.cells[fieldDefinition.metaData.MiniNoteKey] ? item.cells[fieldDefinition.metaData.MiniNoteKey].displayText : ''| sanitizeHtml">
    </div>
</div>-->

<div class="cbc-string-cell">
  <div class="cbc-string-cell-interactions">

    <!-- cell viewer display text -->
    <div *ngIf="item && item.cells" class="grid-cell-ellipsis cbc-string-cell-display-text"
         matTooltip="{{item.cells[fieldDefinition.key] ? item.cells[fieldDefinition.key].displayText : ''}}">
      {{this.item?.cells[this.fieldDefinition.key]?.displayText ? this.item?.cells[this.fieldDefinition.key]?.displayText : ''}}
    </div>

    <div class="cbc-interactions flex flex-row">
      <!-- Refresh icon -->
      <button *ngIf="item.cells[this.fieldDefinition.key]?.metaData?.EnableResetIcon"
              (click)="onClicked('Refresh')"
              mat-icon-button class="reset-icon-dropdown-button">
        <mat-icon>cached</mat-icon>
      </button>

      <!-- Edit icon -->
      <button
        *ngIf="!item?.cells[this.fieldDefinition.key].metaData?.IsReadOnly"
        (click)="onClicked('Edit')" mat-icon-button class="icon-dropdown-button">
        <mat-icon>create</mat-icon>
      </button>

      <!-- Navigate to right side card -->

      <button class="details-btn light-background-button" mat-button
              *ngIf="item?.cells[this.fieldDefinition.key].metaData?.EnableDetailsButton"
              (click)="onClicked('ShowDetails')">
        Details
      </button>

    </div>

  </div>

  <!-- Mini note -->
  <div clsss="grid-cell-ellipsis"
       attr.data-cy="{{item.cells[fieldDefinition.metaData.MiniNoteKey] ? (item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip ? item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip : item.cells[fieldDefinition.metaData.MiniNoteKey].displayText) : ''}}"
       *ngIf="item && item.cells" class="grid-cell-ellipsis"
       matTooltip="{{item.cells[fieldDefinition.metaData.MiniNoteKey] ? (item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip ? item.cells[fieldDefinition.metaData.MiniNoteKey].value?.toolTip : item.cells[fieldDefinition.metaData.MiniNoteKey].displayText) : ''}}"
       [innerHTML]="item.cells[fieldDefinition.metaData.MiniNoteKey] ? (item.cells[fieldDefinition.metaData.MiniNoteKey].displayText | apiColourHtml) : '' | sanitizeHtml">
  </div>

  <!-- show Platform Dialog -->
  <Button
    *ngIf="item.cells[fieldDefinition.key + '_HasDetailText'] && item.cells[fieldDefinition.key + '_HasDetailText'].displayText === 'Yes'"
    class="note-cell-arrow" (click)="openNote()">
    <div class="arrow-left"></div>
  </Button>
</div>
